import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { useApp } from '../context/AppContext';

function getOrCreateSession() {
  let s = localStorage.getItem('pp-vis-sess');
  if (!s) {
    s = 'vs_' + Math.random().toString(36).slice(2, 12) + Date.now().toString(36);
    localStorage.setItem('pp-vis-sess', s);
  }
  return s;
}

/**
 * Fires a lightweight pageview on every route change.
 */
export default function usePageviewTracker() {
  const { API } = useApp();
  const location = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    const path = location.pathname;
    if (lastPath.current === path) return;
    lastPath.current = path;
    const session = getOrCreateSession();
    axios.post(`${API}/analytics/pageview`, {
      path,
      referrer: document.referrer || null,
      user_agent: (navigator.userAgent || '').slice(0, 180),
    }, {
      headers: { 'x-pp-session': session },
    }).catch(() => {});
  }, [location.pathname, API]);
}
